import Pikaday from './pikaday-mod';

export default function bindDateFields() {
  [...document.querySelectorAll('.date-field')].map(field => {
    if (!field.getAttribute('data-init')) {
      field.setAttribute('data-init', true);

      const defaults = {
        field,
        format: 'DD.MM.YYYY.',
      };

      /**
       * OPTIONAL PARAMETERS
       *
       * data-start - int (year), 0 = today
       * data-end - int (year), 0 = today
       * ||
       * data-range - int (range)
       *
       * data-maxdate - new Date()
       * data-mindate - new Date()
      */

      const options = {};

      if (field.getAttribute('data-range')) {
        options.yearRange = field.getAttribute('data-range');
      } else if (
        field.getAttribute('data-start') &&
        field.getAttribute('data-end')
      ) {
        options.yearRange = [
          field.getAttribute('data-start'),
          field.getAttribute('data-end'),
        ];
      }

      if (field.getAttribute('data-mindate')) {
        options.minDate = new Date(field.getAttribute('data-mindate'));
      }

      if (field.getAttribute('data-maxdate')) {
        options.maxDate = new Date(field.getAttribute('data-maxdate'));
      }

      new Pikaday(Object.assign({}, defaults, options));
    }
  });
}



// WEBPACK FOOTER //
// ./src/js/date-fields.js